import { getMimeTypeFromName } from "@@common";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AppMediaClient } from "../../api/AppMediaClient";
import { useApiClient, useErrorHandler } from "../../common/hooks";
import { EMPTY_GUID } from "../../ExpressionsModule/Runtime/Evaluators/DomainServices/EMPTY_GUID";
import { IBundleContext } from "../../UserInterfaceModule/Contexts/BundleContext";

export default function DrawerLogo({ bundle, open }: { bundle: IBundleContext; open: boolean }) {
  const resource = Object.values(bundle.EmbeddedResourceById)[0];
  const client = useApiClient(AppMediaClient);
  const handleError = useErrorHandler();
  const resourceId = resource?.Id;
  const fileId = resource?.FileId;
  const key = JSON.stringify([bundle.Id, resourceId, fileId]);
  const [resolved, setResolved] = useState<{ key: string; url?: string }>();
  const [failedSrc, setFailedSrc] = useState<string>();

  useEffect(() => {
    if (!open || !bundle.Id || !resourceId || !fileId) {
      return;
    }
    const controller = new AbortController();
    client.get(bundle.Id, resourceId, EMPTY_GUID, controller.signal)
      .then(file => {
        if (!controller.signal.aborted) setResolved({ key, url: file.url });
      })
      .catch(error => {
        if (!controller.signal.aborted) {
          setResolved({ key });
          handleError(error);
        }
      });
    return () => controller.abort();
  }, [open, bundle.Id, resourceId, fileId, key, client, handleError]);

  const src = fileId
    ? (resolved?.key === key ? resolved.url : undefined)
    : resource?.Content ? `data:${getMimeTypeFromName(resource.Name)};base64,${resource.Content}` : undefined;
  if (!open || !src || src === failedSrc) return null;

  return <Box sx={{ width: "100%", flexShrink: 0, px: 2, py: 1, display: "flex", justifyContent: "center" }}>
    <Box component="img" src={src} alt={resource?.Name ?? "Logo"} onError={() => setFailedSrc(src)}
      sx={{ maxWidth: "100%", height: "auto", display: "block" }} />
  </Box>;
}
